import { useParams } from "react-router";
import NewLogo from "../NewLogo";

//M&A Acquirer detail indfromation component
const AcquirerDetailInfo = (props) => {

  const {acquirerId} = useParams();
  
  const tagsList = props?.data?.tags?.split(",").map((tag) => {
    const capital = tag.charAt(0).toUpperCase() + tag.slice(1);
    return (
      <li className="mt-2 lg:mt-0 nav-item flex active " role="presentation">
        {capital ? (
          <a className=" lg:block text-[10.7pt] leading-[17pt] lg:leading-[16px] font-sans_book_body px-3 mr-2 py-1 text-center text-[#333333] bg-[#EFEFEF] lg:text-[12px] rounded-[5px]">
            {capital}
          </a>
        ) : null}
      </li>
    );
  });

  return (
    <>
      <div>
        {/* <!-- BarRaiser--> */}
        <div className="pl-5 pr-3">
          <div className=" bg-[#FFFFFF]">
            <ul role="list">
              {Object.keys(props?.data ?? {}).length > 0 ? (
                <>
                  <li className="w-full flex pt-6 bg-[#FFFFFF]">
                    <div className=" rounded-md">
                      <NewLogo menu="ma_acquirer" id={acquirerId} page={"detailPage"}/>
                    </div>

                    <div className="ml-3 flex flex-1 flex-col">
                      <p className="text-[#333333] text-[22px] font-semibold leading-[24px]">
                        {props?.page === "dealPage" ? (
                          props?.data?.companyname
                        ) : (
                          <>
                            {props?.data?.acquirer_name}{" "}
                            {props?.data?.registered_name && (
                              <span className="text-[18px] leading-[20px]">
                                ({props?.data?.registered_name})
                              </span>
                            )}
                          </>
                        )}
                      </p>
                      <span className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body ">
                        {props.data?.acquirer_industry}
                      </span>
                    </div>
                  </li>
                  <li>
                    {props?.data?.tags && props?.data?.tags != "" && (
                      <div className="bg-[#FFFFFF] mt-4">
                        <ul
                          className="nav nav-tabs flex flex-wrap  list-none border-b-0 pl-0 pb-2"
                          id="tabs-tab"
                          role="tablist"
                        >
                          {tagsList}
                        </ul>
                      </div>
                    )}
                  </li>
                  <div>
                    <p class="mt-3 whitespace-pre-line text-[11pt] leading-[18pt] py-1  lg:text-[14px] text-[#333333] lg:leading-[20px] font-sans_book_body"></p>
                  </div>
                </>
              ) : (
                <div className="w-full bg-[#FFFFFF]">
                  <center>
                    <div role="status" className=" h-[8rem]">
                      <svg
                        className="relative top-[4rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  </center>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcquirerDetailInfo;